export default {
  orsLPolyline: {
    type: 'Typ',
    surface: 'Povrch',
    unknownSurfaceType: 'Neznámý'
  }
}
